export default "<p>list-gains-cash works!</p>\n"